import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"

export type MenuGroupProps = {
  /** Menu items and optional header for this group */
  children?: React.ReactNode
}

export function MenuGroup({ children }: MenuGroupProps) {
  return (
    <MenuPrimitive.Group data-slot="menu-group">
      {children}
    </MenuPrimitive.Group>
  )
}

MenuGroup.displayName = "Menu.Group"
